import { render } from "./SI.vue?vue&type=template&id=684375c7&scoped=true"
import script from "./SI.vue?vue&type=script&lang=js"
export * from "./SI.vue?vue&type=script&lang=js"

import "./SI.vue?vue&type=style&index=0&id=684375c7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-684375c7"

export default script